/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast. Keeping your custom
 * Javascript in this file will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // --- LENIS SMOOTH SCROLL CLASS ---
  class SmoothScroll {
    constructor() {
      this._createLenis();
      this._render = this._render.bind(this);
      requestAnimationFrame(this._render);
    }

    _createLenis() {
      this.lenis = new Lenis({
        lerp: 0.04,
        smooth: true
      });
    }

    _render(time) {
      this.lenis.raf(time);
      window.dispatchEvent(new Event('scroll'));
      requestAnimationFrame(this._render);
    }
  }

  // --- DOM READY ---
  document.addEventListener('DOMContentLoaded', () => {

    // --- DRAG SCROLL ---
    document.querySelectorAll('[data-drag-scroll]').forEach(container => {
      let isDown = false;
      let startX, scrollLeft;

      container.querySelectorAll('img').forEach(img => {
        img.setAttribute('draggable', 'false');
      });

      container.addEventListener('mousedown', e => {
        e.preventDefault();
        isDown = true;
        container.classList.add('dragging');
        startX = e.pageX - container.offsetLeft;
        scrollLeft = container.scrollLeft;
      });

      container.addEventListener('mouseleave', () => {
        isDown = false;
        container.classList.remove('dragging');
      });

      container.addEventListener('mouseup', () => {
        isDown = false;
        container.classList.remove('dragging');
      });

      container.addEventListener('mousemove', e => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - container.offsetLeft;
        const walk = (x - startX) * 1.5;
        container.scrollLeft = scrollLeft - walk;
      });
    });

    // --- CUSTOM DROPDOWN TOGGLE ---
    const dropdownToggle = document.querySelector('.custom-dropdown__toggle');
    const dropdownMenu = document.querySelector('.custom-dropdown__menu');

    if (dropdownToggle && dropdownMenu) {
      dropdownToggle.addEventListener('click', () => {
        dropdownMenu.classList.toggle('open');
      });

      document.addEventListener('click', event => {
        if (!dropdownToggle.contains(event.target) && !dropdownMenu.contains(event.target)) {
          dropdownMenu.classList.remove('open');
        }
      });
    }

    // --- NOTIFICATION DRAWER SHOW MORE/LESS ---
    const showMoreBtn = document.getElementById("ShowMoreNotifications");
    const showLessBtn = document.getElementById("ShowLessNotifications");
    const closeBtn = document.getElementById("NotificationClose");
    const preview = document.getElementById("NotificationPreview");
    const full = document.getElementById("NotificationFull");

    showMoreBtn?.addEventListener("click", () => {
      preview.classList.add("hidden");
      full.classList.remove("hidden");
      full.querySelectorAll('.notification-item.hidden').forEach(item => item.classList.remove("hidden"));
      closeBtn.classList.remove("hidden");
    });

    showLessBtn?.addEventListener("click", () => {
      full.classList.add("hidden");
      preview.classList.remove("hidden");
      preview.querySelectorAll('.notification-item.hidden').forEach(item => item.classList.remove("hidden"));
      closeBtn.classList.remove("hidden");
    });


    closeBtn?.addEventListener("click", () => {
      if (!preview.classList.contains("hidden")) {
        preview.querySelector('.notification-item')?.classList.add("hidden");
      }

      if (!full.classList.contains("hidden")) {
        full.querySelectorAll('.notification-item').forEach(item => item.classList.add("hidden"));
        full.classList.add("hidden");
        preview.classList.remove("hidden");
      }

      closeBtn.classList.add("hidden");
    });


    // --- HERO TEXT FIRST WORD BOLD ---
    const heroText = document.querySelector('.hero__description.body-large');
    if (heroText) {
      const words = heroText.textContent.trim().split(' ');
      if (words.length > 1) {
        heroText.innerHTML = `<span class="avantt-extrabold">${words[0]}</span> ${words.slice(1).join(' ')}`;
      }
    }
    // --- DYNAMIC [] RED CLASS ---
      document.querySelectorAll('.dynamic-span-text').forEach(el => {
        el.innerHTML = el.innerHTML.replace(/\[(.*?)\]/g, '<span class="red-word">$1</span>');
      });

  }); // end DOMContentLoaded

  // links open in new tab
  document.addEventListener('DOMContentLoaded', function() {
  let links = document.querySelectorAll('a');

  let domain = window.location.hostname;

  links.forEach(link => {
    if (link.hostname !== domain && link.hostname !== '') {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    }
  });
});


  const clamp = (v, min, max) => Math.max(min, Math.min(max, v));

  function initScrollbar(sectionEl) {
    const scroller = sectionEl.querySelector('.podcast-blog-carousel');
    const track = sectionEl.querySelector('[data-scrollbar-track]');
    const thumb = sectionEl.querySelector('[data-scrollbar-thumb]');
    const wrapper = sectionEl.querySelector('[data-carousel-scrollbar]');

    if (!scroller || !track || !thumb || !wrapper) return;

    let dragging = false;
    let dragStartX = 0;
    let thumbStartLeft = 0;

    const getMaxScroll = () => scroller.scrollWidth - scroller.clientWidth;

    function setThumbSize() {
      const maxScroll = getMaxScroll();
      const trackW = track.clientWidth;

      // If there's nothing to scroll, hide the scrollbar
      if (maxScroll <= 1 || trackW <= 0) {
        wrapper.classList.add('is-hidden');
        return;
      }
      wrapper.classList.remove('is-hidden');

      // Thumb width proportional to visible area
      const ratio = scroller.clientWidth / scroller.scrollWidth;
      const minThumb = 32;
      const thumbW = clamp(trackW * ratio, minThumb, trackW);
      thumb.style.width = `${thumbW}px`;

      updateThumbPosition();
    }

    function updateThumbPosition() {
      const maxScroll = getMaxScroll();
      const trackW = track.clientWidth;
      const thumbW = thumb.offsetWidth;

      if (maxScroll <= 0) {
        thumb.style.left = `0px`;
        return;
      }

      const maxThumbLeft = trackW - thumbW;
      const scrollRatio = scroller.scrollLeft / maxScroll;
      const left = scrollRatio * maxThumbLeft;
      thumb.style.left = `${left}px`;
    }

    function scrollToThumbLeft(leftPx) {
      const maxScroll = getMaxScroll();
      const trackW = track.clientWidth;
      const thumbW = thumb.offsetWidth;

      const maxThumbLeft = Math.max(0, trackW - thumbW);
      const left = clamp(leftPx, 0, maxThumbLeft);
      const ratio = maxThumbLeft > 0 ? left / maxThumbLeft : 0;

      scroller.scrollLeft = ratio * maxScroll;
    }

    // Keep thumb synced while user scrolls the carousel
    scroller.addEventListener('scroll', updateThumbPosition, { passive: true });

    // Clicking the track jumps the thumb (and scroll)
    track.addEventListener('pointerdown', (e) => {
      // If they grabbed the thumb, thumb handler will manage it
      if (e.target === thumb) return;

      const rect = track.getBoundingClientRect();
      const thumbW = thumb.offsetWidth;
      const clickX = e.clientX - rect.left;

      // Center thumb around click
      scrollToThumbLeft(clickX - thumbW / 2);
    });

    // Dragging the thumb
    thumb.addEventListener('pointerdown', (e) => {
      dragging = true;
      thumb.setPointerCapture(e.pointerId);

      const rect = track.getBoundingClientRect();
      dragStartX = e.clientX - rect.left;
      thumbStartLeft = parseFloat(getComputedStyle(thumb).left) || 0;

      e.preventDefault();
    });

    thumb.addEventListener('pointermove', (e) => {
      if (!dragging) return;

      const rect = track.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const delta = x - dragStartX;

      scrollToThumbLeft(thumbStartLeft + delta);
    });

    thumb.addEventListener('pointerup', () => {
      dragging = false;
    });
    thumb.addEventListener('pointercancel', () => {
      dragging = false;
    });

    // Recalc on resize / images loading
    const ro = new ResizeObserver(() => setThumbSize());
    ro.observe(scroller);
    ro.observe(track);

    // Initial
    setThumbSize();

    // If images load later and change widths
    window.addEventListener('load', setThumbSize, { once: true });
  }

  function initAll() {
    document.querySelectorAll('[data-section-type="blog"], [data-section-type="reels"]')
    .forEach(initScrollbar);
  }

  // Run now + also when Shopify editor reloads sections
  initAll();
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target?.matches?.('[data-section-type="blog"], [data-section-type="reels"]')) initScrollbar(e.target);
  });



  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

